import { getCsrfToken, reportApiError } from '../API/config';
import { markReported } from './errorReporting';

/**
 * Authenticated fetch wrapper for API requests.
 */
export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
  const token = localStorage.getItem('token');
  const csrfToken = getCsrfToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    ...options.headers,
  } as HeadersInit;

  const method = (options.method ?? 'GET').toUpperCase();

  let response: Response;
  try {
    response = await fetch('/api' + url, { ...options, headers });
  } catch (networkError) {
    // The request never completed -- no status to key off, so report it the
    // same way RTK Query's FETCH_ERROR is reported.
    reportApiError({ status: 'FETCH_ERROR', error: String(networkError) }, {
      url,
      method,
    });
    throw networkError;
  }

  if (response.status === 204) {
    return null;
  }

  let data;
  try {
    data = await response.json();
  } catch (parseError) {
    reportApiError({ status: response.status, error: String(parseError) }, {
      url,
      method,
    });
    throw parseError;
  }

  if (!response.ok) {
    reportApiError({ status: response.status, data }, { url, method });
    // Callers read `.detail` / `.message` off the body, so the raw body stays
    // the thrown value; Sentry already has a normalized copy.
    markReported(data);
    throw data;
  }
  return data;
};
